import { render, staticRenderFns } from "./MoviesTop.vue?vue&type=template&id=d8b459ec&"
import script from "./MoviesTop.vue?vue&type=script&lang=js&"
export * from "./MoviesTop.vue?vue&type=script&lang=js&"
import style0 from "./MoviesTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports